// ui/src/views/Reembolso/categorias.ts
// 13 categorias reais do de/para Protheus (spec §4.1). 'outros'/'transporte' são legadas.
export const CATEGORIA_OPTIONS = [
  { value: 'alimentacao', title: 'Alimentação' },
  { value: 'hospedagem', title: 'Hospedagem' },
  { value: 'pedagio', title: 'Pedágio' },
  { value: 'estacionamento', title: 'Estacionamento' },
  { value: 'transp_terrestre', title: 'Transporte terrestre' },
  { value: 'pass_aerea', title: 'Passagem aérea' },
  { value: 'loc_automovel', title: 'Locação de automóvel' },
  { value: 'manut_veic', title: 'Manutenção veicular' },
  { value: 'telefone', title: 'Telefone' },
  { value: 'capa_pelic_cel', title: 'Capa/película de celular' },
  { value: 'mat_esc', title: 'Material de escritório' },
  { value: 'cursos', title: 'Cursos' },
  { value: 'serv_inf', title: 'Serviços de informática' },
] as const;

export const CATEGORIA_LABEL: Record<string, string> = Object.fromEntries(
  CATEGORIA_OPTIONS.map((o) => [o.value, o.title]),
);
CATEGORIA_LABEL.transporte = 'Transporte (legado)';
CATEGORIA_LABEL.outros = 'Outros (legado)';
